(function () {
  function getMOQ(input) {
    var moq = parseInt(input.getAttribute('data-moq'), 10);
    return !isNaN(moq) && moq > 0 ? moq : 1;
  }

  function getQty(input) {
    var qty = parseInt(input.value, 10);
    return isNaN(qty) ? 0 : qty;
  }

  function isQuoteQtyInput(input) {
    return (
      input &&
      input.matches &&
      input.matches('.quote-requested-quantity-input')
    );
  }

  function notifyQuantityChange(input) {
    input.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    input.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

  function enforceMOQ(input) {
    if (!isQuoteQtyInput(input)) return false;

    var moq = getMOQ(input);
    var qty = getQty(input);

    if (qty < moq) {
      input.value = moq;
      return true;
    }

    return false;
  }

  function initQuoteQuantity() {
    /*
     * Minus button
     */
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.quote-qty-minus');

        if (!button) return;

        var wrapper = button.closest('.quote-requested-quantity');
        if (!wrapper) return;

        var input = wrapper.querySelector(
          '.quote-requested-quantity-input'
        );

        if (!input) return;

        var moq = getMOQ(input);
        var qty = getQty(input);

        if (qty <= moq) {
          input.value = moq;
          return;
        }

        input.value = qty - 1;
        notifyQuantityChange(input);
      }
    );

    /*
     * Plus button
     */
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.quote-qty-plus');

        if (!button) return;

        var wrapper = button.closest('.quote-requested-quantity');
        if (!wrapper) return;

        var input = wrapper.querySelector(
          '.quote-requested-quantity-input'
        );

        if (!input) return;

        var qty = getQty(input);

        if (qty < 1) {
          qty = getMOQ(input);
        }

        input.value = qty + 1;
        notifyQuantityChange(input);
      }
    );

    /*
     * Manual entry
     */
    document.addEventListener(
      'change',
      function (event) {
        var input = event.target;

        if (!isQuoteQtyInput(input)) return;

        if (enforceMOQ(input)) {
          notifyQuantityChange(input);
        }
      }
    );

    /*
     * When leaving the field
     */
    document.addEventListener(
      'blur',
      function (event) {
        var input = event.target;

        if (!isQuoteQtyInput(input)) return;

        if (enforceMOQ(input)) {
          notifyQuantityChange(input);
        }
      },
      true
    );

    /*
     * Initial validation
     */
    document
      .querySelectorAll('.quote-requested-quantity-input')
      .forEach(function (input) {
        enforceMOQ(input);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initQuoteQuantity
    );
  } else {
    initQuoteQuantity();
  }
})();